export const AuthApiConfig: any = {
  SIGNIN: {
    url: "/google/login",
    method: "post",
    service: "AUTH_CENTRAL",
  },
};
